import { twMerge } from "tailwind-merge";
import clsx from "clsx";

interface Tab { value: string; label: string; count?: number; }

export function Tabs({
  tabs, value, onChange,
}: { tabs: Tab[]; value: string; onChange: (v: string) => void }) {
  return (
    <div className="border-b border-surface-200 flex gap-1 overflow-x-auto">
      {tabs.map((t) => (
        <button
          key={t.value}
          onClick={() => onChange(t.value)}
          className={twMerge(clsx(
            "px-4 py-2.5 text-sm font-medium border-b-2 -mb-px flex items-center gap-2 whitespace-nowrap",
            t.value === value
              ? "border-brand-600 text-brand-700"
              : "border-transparent text-surface-500 hover:text-surface-800 hover:border-surface-300",
          ))}
        >
          {t.label}
          {typeof t.count === "number" && (
            <span className={twMerge(clsx(
              "text-2xs font-semibold px-1.5 py-0.5 rounded",
              t.value === value ? "bg-brand-100 text-brand-700" : "bg-surface-100 text-surface-600",
            ))}>{t.count}</span>
          )}
        </button>
      ))}
    </div>
  );
}
